import { all, put } from 'redux-saga/effects';

import { store } from '../store';
import { send } from '../../helpers/requests';
import * as actions from './actions';
import toastr from '../../helpers/toastr';
import AnalyticsClient from '../../analytics/analyticsClient';
import trackEvents from '../../analytics/trackEvents';
import { selectToken } from '../selectors';

export function* bulkInviteRequestSaga(payload) {
  try {
    const _store = store.getState();
    const token = selectToken(_store);
    yield all(
      payload.data.team.map(function* (user) {
        if (user.role) {
          yield send({
            url: `/users/${payload.data.id}`,
            method: 'POST',
            data: {
              role: user.role,
            },
            token,
          });
          AnalyticsClient.track(trackEvents.TEAM_UPDATE_ROLE);
        }
      })
    );
    const res = yield send({
      url: `/team/bulk-invite`,
      method: 'POST',
      data: {
        team: payload.data.team,
      },
      token,
    });
    yield put(actions.bulkInviteRequestSuccess(res));
    toastr.success(`Successfully sent ${payload?.data?.team?.length || 'N/A'} invitations`);
    yield put(actions.getTeamRequest());
    AnalyticsClient.track(trackEvents.TEAM_INVITE, { count: payload?.data?.team?.length || 'N/A' });
  } catch (error) {
    yield put(actions.bulkInviteRequestFailure(error));
  }
}

export function* getTeamRequestSaga() {
  try {
    const res = yield send({
      url: '/team',
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getTeamRequestSuccess(res));
  } catch (error) {
    yield put(actions.getTeamRequestFailure(error));
  }
}

export function* inviteUserRequestSaga(payload) {
  try {
    const _store = store.getState();
    const token = selectToken(_store);
    if (payload.data.role) {
      yield send({
        url: `/users/${payload.data.id}`,
        method: 'PUT',
        data: {
          role: payload.data.role,
        },
        token,
      });
      AnalyticsClient.track(trackEvents.TEAM_UPDATE_ROLE);
    }
    const res = yield send({
      url: `/team/${payload.data.id}/invite`,
      method: 'POST',
      data: payload.data.data,
      token,
    });
    yield put(actions.inviteUserRequestSuccess(res));
    toastr.success('Invitation successfully sent!');
    yield put(actions.getTeamRequest());
    AnalyticsClient.track(trackEvents.TEAM_INVITE, { count: 1 });
  } catch (error) {
    yield put(actions.inviteUserRequestFailure(error));
  }
}
